"use client";

import React, { useState, useEffect, useRef } from "react";
import AIDICSDiagram from "./AIDICSDiagram";

interface AIDICSStep {
  id: string;
  name: string;
  value: string;
  number: number;
  content: React.ReactNode;
}

interface AIDICSTabsProps {
  steps: AIDICSStep[];
  autoPlay?: boolean;
  autoPlayInterval?: number;
  currentValue?: string;
  onChange?: (value: string) => void;
}

const AIDICSTabs: React.FC<AIDICSTabsProps> = ({
  steps,
  autoPlay = true,
  autoPlayInterval = 5000,
  currentValue,
  onChange,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Sync with parent component
  useEffect(() => {
    if (currentValue) {
      const index = steps.findIndex(step => step.value === currentValue);
      if (index !== -1) {
        setActiveIndex(index);
      }
    }
  }, [currentValue, steps]);

  // Reset pause when manually changing tab
  const handleStepClick = (index: number) => {
    setActiveIndex(index);
    onChange?.(steps[index].value);
    setIsPaused(true);
    
    // Resume after a delay
    setTimeout(() => setIsPaused(false), 3000);
  };

  return (
    <div
      className="w-full"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Animated Diagram */}
      <div className="flex justify-center">
        <AIDICSDiagram
          activeStep={activeIndex}
          onStepClick={handleStepClick}
        />
      </div>
    </div>
  );
};

export default AIDICSTabs;